var map = {
	"./down_full_color.svg": 52242,
	"./icon_add.svg": 61273,
	"./icon_close.svg": 49436,
	"./icon_close_no_bag.svg": 11073,
	"./icon_del.svg": 70951,
	"./icon_document_center.svg": 90941,
	"./icon_download.svg": 12312,
	"./icon_edit.svg": 77052,
	"./icon_logo.svg": 70077,
	"./icon_no_auth.svg": 77314,
	"./icon_ppt.svg": 31860,
	"./icon_publish.svg": 63761,
	"./icon_tag_close.svg": 79457,
	"./icon_upload.svg": 86579,
	"./icon_view.svg": 9827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;